<template>
  <el-card :body-style="{ height: '100%', overflow: 'auto' }" class=" h-full">
    <div class="mb-20px flex items-center">
      <el-button
        size="small"
        type="primary"
        @click="jumpHome"
        class="mr-10px"
        v-if="type === 'read'"
      >
        {{ $t('返回') }}
      </el-button>
      <div class="border-l-3px border-$systemMainColor pl-10px">{{ title }}</div>
    </div>
    <div :class="type === 'read' ? 'h-[calc(100%-56px)]' : 'h-[calc(100%-100px)]'">
      <el-table
        :data="tableData"
        v-loading="tableLoading"
        ref="table"
        border
        height="100%"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column type="index" :label="$t('序号')" width="50" />
        <el-table-column
          :prop="item.prop"
          :label="$t(item.label)"
          v-for="(item, index) in tableColumns"
          :key="index"
          show-overflow-tooltip
          :min-width="item.minWidth"
        >
          <template slot-scope="scope">
            <el-input-number
              size="medium"
              v-model="scope.row[item.prop]"
              v-if="item.type === 'edit'"
              :disabled="type === 'read'"
              :step="50"
              class="!w-[calc(100%-20px)]]"
            ></el-input-number>
            <span v-if="item.type === 'edit'"> %</span>
            <div
              v-else-if="
                item.prop === 'internalAvg' ||
                  item.prop === 'provinceAvg' ||
                  item.prop === 'groupAvg' ||
                  item.prop === 'taskAvg' ||
                  item.prop === 'groupReward' ||
                  item.prop === 'otherReward' ||
                  item.prop === 'monthAvg' ||
                  item.prop === 'groupExceedReword'
              "
            >
              {{ scope.row[item.prop] }}%
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="w-full mt-20px flex justify-center items-center" v-if="type !== 'read'">
      <el-button size="small" type="primary" v-if="type !== 'read'" @click="updateTableData">
        {{ $t('保存') }}
      </el-button>
      <el-button size="small" type="primary" v-if="type !== 'read'" @click="jumpHome">
        {{ $t('取消') }}
      </el-button>
    </div>
  </el-card>
</template>

<script>
// tool
import { map, get } from 'lodash'
import dayjs from 'dayjs'
// api
import { RoyaltiesTargetStatisticsApi } from '@wiz-api/workbench'

const royaltiesTargetStatisticsApi = new RoyaltiesTargetStatisticsApi()

export default {
  data() {
    return {
      tableData: [],
      tableLoading: false,
      tableColumns: [
        { prop: 'deptName', label: '部门', minWidth: 100 },
        { prop: 'internalTarget', label: '内网目标', minWidth: 80 },
        { prop: 'internalFinish', label: '内网完成', minWidth: 80 },
        { prop: 'internalAvg', label: '内网完成率', minWidth: 105 },
        { prop: 'provinceTarget', label: '广东目标', minWidth: 80 },
        { prop: 'provinceFinish', label: '广东完成', minWidth: 80 },
        { prop: 'provinceAvg', label: '广东完成率', minWidth: 105 },
        { prop: 'groupTarget', label: '集团目标', minWidth: 80 },
        { prop: 'groupFinish', label: '集团完成', minWidth: 80 },
        { prop: 'groupAvg', label: '集团完成率', minWidth: 105 },
        { prop: 'taskAvg', label: '任务稿件完成率', minWidth: 135 },
        { prop: 'groupExceed', label: '集团以上超篇数', minWidth: 120 },
        { prop: 'groupExceedReword', label: '集团级完成奖励', minWidth: 120 },
        { prop: 'groupReward', label: '集团级完成率奖励', type: 'edit', minWidth: 240 },
        { prop: 'otherReward', label: '其他完成率奖励', type: 'edit', minWidth: 240 },
        { prop: 'monthAvg', label: '月度综合完成率', minWidth: 135 },
        { prop: 'finishRanking', label: '任务完成综合排名', minWidth: 140 },
      ],
    }
  },
  computed: {
    type() {
      return get(this.$route.query, 'type') || ''
    },
    time() {
      return dayjs(get(this.$route.query, 'time') || new Date()).format('YYYY-MM-01 HH:mm:ss')
    },
    title() {
      if (this.type === 'read') {
        return this.$t('宣传月度详情')
      }
      return this.$t('宣传月度统计')
    },
    routerBase() {
      if (window.__POWERED_BY_QIANKUN__) {
        return `/${_.get(Wiz, 'globalSettings.globalConfig.routerBase')}`
      }
      return ''
    },
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => {
          return Number(item[column.property])
        })
        if (
          column.property === 'internalTarget' ||
          column.property === 'internalFinish' ||
          column.property === 'provinceTarget' ||
          column.property === 'provinceFinish' ||
          column.property === 'groupTarget' ||
          column.property === 'groupFinish'
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!_.isNaN(value)) {
              return _.round(prev + curr, 2)
            }
            return prev
          }, 0)
          sums[index]
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    async getTableData() {
      const [err, res] = await royaltiesTargetStatisticsApi.list({ time: this.time })
      if (!err) {
        this.tableData = map(res, (item) => {
          return {
            ...item,
            creationTime: dayjs(item.creationTime).format('YYYY-MM-DD HH:mm:ss'),
            time: dayjs(item.time).format('YYYY-MM-DD HH:mm:ss'),
          }
        })
      }
    },
    jumpHome() {
      this.$router.push({
        path: `${this.routerBase}/portal-management/royalties-management/propaganda-monthly-statistics`,
      })
    },
    async updateTableData() {
      const updateArray = map(this.tableData, (item) => {
        return {
          id: item.statisticId,
          deptId: item.deptId,
          time: item.time,
          groupReward: item.groupReward,
          otherReward: item.otherReward,
        }
      })
      const [err, res] = await royaltiesTargetStatisticsApi.update({
        body: updateArray,
      })
      if (!err) {
        this.$message.success(this.$t('更新成功'))
        this.jumpHome()
      }
    },
  },
  created() {
    this.getTableData()
  },
  updated() {
    this.$nextTick(() => {
      this.$refs.table.doLayout()
    })
  },
}
</script>
